import type BookWithMeOrganizerStore from './schema/BookWithMeOrganizerStore';
import { createStore } from 'owa-satcheljs';
import type ServicesRequestStatus from './schema/ServicesRequestStatus';
import type PersonalBookingPageShownView from './schema/PersonalBookingPageShownView';
import type PersonalBookingPagePublishingSettings from './schema/PersonalBookingPagePublishingSettings';
import initializeMeetingTypeEditState from '../utils/initializeMeetingTypeEditState';
import initBookingDashboard from '../utils/initBookingDashboard';
import type PublishingSettings from 'owa-service/lib/contract/PublishingSettings';
import createEmptySharedViewState from '../utils/createEmptySharedViewState';
import { FREState } from '../store/schema/FREState';
import { DEFAULT_ENTRYPOINT } from 'bookwithme-shared';
import {
    PublishStatus,
    AutoPublishState,
    UserOnboardingState,
} from './schema/BookWithMeOrganizerStore';

const initPublishingSettings: PublishingSettings = {
    IsPublished: false,
    PageOrigin: '',
};

const initPbpPublishingSetting: PersonalBookingPagePublishingSettings = {
    publishingSettings: initPublishingSettings,
    isAnonymousSharingEnabled: true,
    getPbpSettingRequestStatus: 0,
    getMeetingTypeExtensionRequestStatus: 0,
};
const initialBookWithMeOrganizerStore: BookWithMeOrganizerStore = {
    selectedReadPivot: null,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function initBookingDashboard called at module scope is not allowed. This may cause unwanted side effects. */
    bookingDashboard: initBookingDashboard(),
    meetingTypes: null,
    currentMeetingTypeId: null,
    // To store the number of reminders before updation
    // TODO: Can be removed after B2 migration as it will be stored in meetingTypes
    inboxReminders: [],
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function createEmptySharedViewState called at module scope is not allowed. This may cause unwanted side effects. */
    sharedViewState: createEmptySharedViewState(),
    // To check whether the user is creating a new service or editing an existing service.
    // TODO: Can be removed after B2 migration
    isCreate: false,
    isSaving: false,
    isTurningOnBookingPage: false,
    isPerformingServiceUpdate: false,
    getServicesRequestStatus: 0,
    shownView: 0,
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function initializeMeetingTypeEditState called at module scope is not allowed. This may cause unwanted side effects. */
    meetingTypeEditState: initializeMeetingTypeEditState(),
    pbpPublishingSetting: initPbpPublishingSetting,
    meetingTypeExtensions: null,
    meetingTypeExtension: null,
    firstTimeUser: false,
    firstRunState: FREState.Welcome,
    mailboxHash: '',
    entryPoint: DEFAULT_ENTRYPOINT,
    BookingPagePublishedStatus: PublishStatus.Pending,
    organizerProfilePicture: undefined,
    isGettingBookingSessionData: true,
    pbEnabledStatus: 0,
    // by default teams meeting is enabled to keep the old behavior
    // while the flight Teams Toggle is been tested
    isTeamsMeetingEnabled: true,
    // By defualt we set the status to pending
    // if !firstTimeUser we dont use this state
    // if firstTimeUser we check to make sure it is complete before rendering publish button
    newUserAutoPublishState: AutoPublishState.Pending,
    userOnboardingState: UserOnboardingState.UserPreviousFlowOnboarded,
    masterPublished: false,
    checkBookingPagePublishedIsCalled: false,
    bookingMailboxPuid: '',
    showServiceOutageBanner: false,
    isPageSharedOrEmailSignatureAdded: false,
    isUpdateUserConfigInitiated: false,
    linkGeneratedServiceIds: [],
};

const getStore = createStore<BookWithMeOrganizerStore>(
    'bookwithme-organizer',
    initialBookWithMeOrganizerStore
);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function getStore called at module scope is not allowed. This may cause unwanted side effects. */
export default getStore();
